"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoScopedLogger = void 0;
class NoScopedLogger {
    constructor() {
        this.$name = 'no-scoped-logger';
    }
    debug(obj) {
    }
    error(obj) {
    }
    info(obj) {
    }
    fork() {
        return new NoScopedLogger();
    }
    mergeIn(logger) {
    }
    print(logger) {
    }
    toLog() {
        return null;
    }
    toLogs() {
        return [];
    }
}
exports.NoScopedLogger = NoScopedLogger;
NoScopedLogger.instance = new NoScopedLogger();
//# sourceMappingURL=no-scoped-logger.js.map